// extracted by mini-css-extract-plugin
export default {"accordianContainer":"TermWiseHistoryList__accordianContainer___RgqTv"};